export const CREATE_SESSION_TEXT = 'Create a Session';
export const SESSION_EXISTS_TEXT =
  'An active session already exists for this Spotify URI. Please choose another.';
export const SELECT_GENRE = 'Please select a genre for your session';
export const GENRE_TEXT = 'Song Genre';
export const GENRE_TEXT_SELECTED = 'Selected Genre';
export const GENRE_SUB_TEXT_UNSELECTED =
  'Does this song match your preferred genres? (Choose 1)';
export const GENRE_SUB_TEXT_SELECTED = '';
